const fullHex = (hex: string) => {
  let r = hex.slice(1, 2);
  let g = hex.slice(2, 3);
  let b = hex.slice(3, 4);

  r = parseInt(r + r, 16).toString();
  g = parseInt(g + g, 16).toString();
  b = parseInt(b + b, 16).toString();

  return `rgba(${r},${g},${b},1)`;
};

export const rgbaToHex = (rgba: string) => {
  const match = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
  if (!match) return '#fff';

  const r = parseInt(match[1], 10);
  const g = parseInt(match[2], 10);
  const b = parseInt(match[3], 10);

  const toHex = (n: number) => n.toString(16).padStart(2, '0');

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toUpperCase();
};

export const hexToRGB = (color?: string) => {
  if (!color) return '';
  if (color.includes('rgb')) return color;

  // if hex only 4 string, example #fff
  if (color.length === 4) {
    return fullHex(color);
  }

  const r = parseInt(color.slice(1, 3), 16).toString();
  const g = parseInt(color.slice(3, 5), 16).toString();
  const b = parseInt(color.slice(5, 7), 16).toString();

  return `rgba(${r},${g},${b},1)`;
};

export const getContrastingTextColor = (rgbaString: string): string => {
  const match = rgbaString.match(
    /^rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})(?:, ?([0-9.]+))?\)$/i
  );

  if (!match) {
    console.warn('Invalid RGBA string:', rgbaString);
    return '#000000';
  }

  const [, rStr, gStr, bStr] = match;
  const r = parseInt(rStr, 10);
  const g = parseInt(gStr, 10);
  const b = parseInt(bStr, 10);

  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;

  return luminance > 186 ? '#000000' : '#FFFFFF';
};
